import { useState, useEffect } from 'react'

export default function GrowthPortalPage() {
  const [loading, setLoading] = useState(true)

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#001529', color: '#fff', padding: '8px 16px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span>📚 成长档案系统</span>
        <span style={{ color: '#888', fontSize: 11 }}>— 博小兔成长档案管理后台</span>
      </div>
      <div style={{ flex: 1, position: 'relative' }}>
        {loading && (
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#888', fontSize: 14 }}>
            加载中...
          </div>
        )}
        <iframe
          src="https://growth.boxiaotu.cn/admin-5182/"
          style={{ width: '100%', height: '100%', border: 'none' }}
          onLoad={() => setLoading(false)}
          title="成长档案系统"
        />
      </div>
    </div>
  )
}
